import React, { ReactNode, VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineConnector from '@material-ui/lab/TimelineConnector';

const useStyles = makeStyles((theme) => ({
  timelineDot: {
    alignItems: 'center',
    boxShadow: 'none',
    border: 'none',
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
  },
  timelineIcon: {
    width: 40,
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      width: 50,
    },
  },
}));

interface Props {
  hasConnector?: boolean;
  children: ReactNode;
}
const AccordionTimelineSeparator: VFC<Props> = ({
  hasConnector,
  children,
}: Props) => {
  const classes = useStyles();
  return (
    <TimelineSeparator>
      <TimelineDot color="inherit" className={classes.timelineDot}>
        {children}
      </TimelineDot>
      {hasConnector && <TimelineConnector />}
    </TimelineSeparator>
  );
};

export default AccordionTimelineSeparator;
